import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Button } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { HelpCircle } from "lucide-react";
import { useTemplateQuery, useTemplateVersionsQuery } from "../api/queries";
import { TemplateDetailTour, useTemplateDetailTour } from "../tour/TemplateDetailTour";
import { TemplateDetailView } from "../ui/TemplateDetailView";

export function TemplateDetailPage() {
  const { id } = useParams({ from: "/app/template/$id" });
  const nav = useNavigate({ from: "/app/template/$id" });
  const template = useTemplateQuery(id);
  const versions = useTemplateVersionsQuery(id);
  const canEdit = useActionPermission(["template:update"]);
  const tour = useTemplateDetailTour();

  if (template.isLoading) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <div className="mx-auto h-8 w-8 animate-spin rounded-full border-primary border-b-2" />
              <p className="mt-2 text-muted-foreground">ກຳລັງໂຫຼດ...</p>
            </div>
          </div>
        </Main>
      </>
    );
  }

  if (!template.data) {
    return (
      <>
        <Header />
        <Main>
          <div className="flex min-h-[400px] items-center justify-center">
            <div className="text-center">
              <h2 className="mb-2 font-bold text-2xl text-destructive">
                ບໍ່ພົບຮ່າງເອກະສານ
              </h2>
              <p className="mb-4 text-muted-foreground">
                ຮ່າງເອກະສານທີ່ທ່ານຊອກຫາບໍ່ມີຢູ່ ຫຼື ຖືກລຶບໄປແລ້ວ
              </p>
            </div>
          </div>
        </Main>
      </>
    );
  }

  return (
    <>
      <Header />
      <Main>
        <TemplateDetailTour run={tour.run} onCallback={tour.handleJoyrideCallback} />
        <div className="mb-4 flex justify-end">
          <Button
            variant="ghost"
            size="icon"
            className="size-7 rounded-full"
            onClick={tour.startTour}
          >
            <HelpCircle className="size-5" />
          </Button>
        </div>
        <TemplateDetailView
          template={template.data}
          versions={versions.data}
          onEdit={() => nav({ to: `/app/template/${id}/edit` })}
          canEdit={!!canEdit}
        />
      </Main>
    </>
  );
}
